import _ from 'lodash';
import { deleteReferenceCitationsFromComponents } from 'modules/References/services/deleteReferenceCitationsFromComponents';
import { call } from 'redux-saga/effects';
import * as Models from 'models';
import { isReferenceCitation } from 'utils/entityType';

// TODO: Revise, it should process both layers
export function* removeUnusedReferences<T extends Models.RefreshProcessArgs>(
  args: T,
): Generator<unknown, T, ReturnTypeSaga<typeof deleteReferenceCitationsFromComponents>> {
  const { assets, prevAssets } = args;
  const { documents, relations } = assets;
  const { documents: prevDocuments } = prevAssets;

  // get deleted reference citation ids
  const deletedReferenceCitationIds = _(prevDocuments)
    .pickBy((document, id) => !documents[id] && isReferenceCitation(document))
    .keys()
    .value();

  // remove deleted reference citations from components
  const deleteReferenceCitationResult = yield call<typeof deleteReferenceCitationsFromComponents>(
    deleteReferenceCitationsFromComponents,
    deletedReferenceCitationIds,
    documents,
    relations,
  );

  assets.documents = deleteReferenceCitationResult.documents;
  assets.relations = deleteReferenceCitationResult.relations;

  return args;
}
